/*
 * @Author: liuxiaoyan
 * @Date: 2022-10-31 15:57:09
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-11-21 09:45:27
 * @Description: cookie类
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
class Cookie {
  constructor() {

  }
  clearCookie(name) {
    this.setCookie(name, "", -1);
  }
  setCookie(name, value, seconds) {
    seconds = seconds || 0;
    var expires = "";
    if (seconds != 0 ) {      //设置cookie生存时间
      var date = new Date();
      date.setTime(date.getTime()+(seconds*1000));
      expires = `; expires=${date.toGMTString()}`;
    }
    document.cookie = `${name}=${escape(value)}${expires}; path=/`;   //转码并赋值
  }
  getCookie(name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';') // 把cookie分割成组
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i] // 取得字符串
      while (c.charAt(0) == ' ') { // 判断一下字符串有没有前导空格
        c = c.substring(1, c.length) // 有的话，从第二位开始取
      }
      if (c.indexOf(nameEQ) === 0) { // 如果含有我们要的name
        return unescape(c.substring(nameEQ.length, c.length)) // 解码并截取我们要值
      }
    }
    return false
  }
}

window.CK = new Cookie();


// WEBPACK FOOTER //
// ./src/core/cookie.js